import { useEffect, useState } from 'react'

/**
 * Counts down from `seconds` to 0 and restarts automatically.
 * Returns the remaining time formatted as MM:SS.
 */
export function useCountdown(seconds: number) {
  const [remaining, setRemaining] = useState(seconds)

  useEffect(() => {
    const id = setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? seconds : prev - 1))
    }, 1000)
    return () => clearInterval(id)
  }, [seconds])

  const mm = String(Math.floor(remaining / 60)).padStart(2, '0')
  const ss = String(remaining % 60).padStart(2, '0')

  return { label: `${mm}:${ss}`, remaining }
}
